import InternalLinkLib from '../components/shared/internal-link-lib';
import { publishTopicOnChannel } from '../services/external-pub-sub/pub-sub-utils';
import {
  eTopics,
  eChannels,
  ePublishers,
} from '../utils/enums';


export function exposeCTAs() {
  window.SportClient = window.SportClient || {};

  window.SportClient.CTA = {
    OpenCashier: (tabId = null, promoCode = null) => {
      const channel = eChannels.payments;
      const topic = eTopics.payments.CTA_Cashier_Open;
      const method = 'OpenCashier()', data = { TabId: tabId, PromoCode: promoCode },
        headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenMyAccount: (tabId = null) => {
      const channel = eChannels.player;
      const topic = eTopics.player.CTA_MyAccount_Open;
      const method = 'OpenMyAccount()', data = { TabId: tabId }, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenCasino: () => {
      const channel = eChannels.crosssell;
      const topic = eTopics.crosssell.CTA_CasinoClient_Open;
      const method = 'OpenCasino()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenExternalLink: (url = null) => {
      const channel = eChannels.crm;
      const topic = eTopics.crm.CTA_ExternalLink_Open;
      const method = 'OpenExternalLink()', data = { Url: url }, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenPoker: () => {
      const channel = eChannels.crosssell;
      const topic = eTopics.crosssell.CTA_PokerClient_Open;
      const method = 'OpenPoker()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenRegistration: () => {
      const channel = eChannels.player;
      const topic = eTopics.player.CTA_NRS_Open;
      const method = 'OpenRegistration()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenClientDeeplink: (navToPath) => {
      InternalLinkLib.goToInternalRoute(navToPath);
    },
    OpenLiveDealer: () => {
      const channel = eChannels.crosssell;
      const topic = eTopics.crosssell.CTA_LiveDealer_Open;
      const method = 'OpenLiveDealer()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenVegas: () => {
      const channel = eChannels.crosssell;
      const topic = eTopics.crosssell.CTA_Vegas_Open;
      const method = 'OpenVegas()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    OpenRich: (campaignId) => {
      const channel = eChannels.crm;
      const topic = eTopics.crm.CTA_RICH_Open;
      const method = 'OpenRich()', data = { CampaignId: campaignId }, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    Login: () => {
      const channel = eChannels.player;
      const topic = eTopics.player.CTA_Login_Request_Submit;
      const method = 'Login()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    },
    Logout: () => {
      const channel = eChannels.player;
      const topic = eTopics.player.CTA_Logout_Request_Submit;
      const method = 'Logout()', data = null, headers = { publisher: ePublishers.sportclient };
      publishTopicOnChannel(topic, channel, method, data, headers);
    }
  };
}

